'use strict';

const _ = require('lodash');
const Moment = require('moment');

const ListController = function ($scope, $rootScope, Flux, NavActions, SaturnGrowl) {

  const vm = this;

  const MeasurementStore = Flux.Store.get('MeasurementStore');
  const DataCaptureStore = Flux.Store.get('DataCaptureStore');
  const MapActions = Flux.Actions.get('MapActions');
  const TopControlsStore = Flux.Store.get('TopControlsStore');

  vm.measurements = [];

  vm.groupedList = [];
  vm.filteredList = [];
  vm.searchTerm = '';

  vm.itemClassFn = (data) => {

    if (data.status === 'error') {
      return '-error .fa-icon-terrain-data-alert';
    }
    return (data.status === 'new' || data.status === 'processing') ? '-processing' : '';
  };

  // Format measurement to display in list widget
  const formatMeasurement = (measurement) => {

    const availableDataCaptures = DataCaptureStore.get('available');
    const dataCapture = _.find(availableDataCaptures, {
      id: measurement.dataCaptureId
    });
    const volString = _.get(measurement, ['result', 'properties', 'fillVolume']) ?
      ' (' + parseInt(_.get(measurement, ['result', 'properties', 'fillVolume']) * 10, 10) / 10 + ' m^2)' : '';
    return {
      name: measurement.name + volString,
      id: measurement.id,
      status: measurement.status,
      dataCaptureDate: Moment(dataCapture.capturedAt).format('YYYY/MM/DD'),
      _permissions: measurement._permissions
    };
  };

  const _loadMeasurements = () => {

    vm.useMapboxGL = TopControlsStore.get('useMapboxGL');
    let available = MeasurementStore.get('available');
    const availableDataCaptures = DataCaptureStore.get('available');

    let current;

    if (available) {
      available = _.sortBy(available ,'createdAt').slice().reverse();
      vm.measurements = available
      .filter((measurement) => {

        const isVisible = (measurement.status === 'completed' && measurement.result) || measurement.status === 'processing' || measurement.status === 'error' || measurement.status === 'new';
        const dataCaptureExists = _.find(availableDataCaptures, { id: measurement.dataCaptureId });
        return isVisible && dataCaptureExists;
      })
      .map(formatMeasurement);
      current = MeasurementStore.get('current');

      vm.groupedList = _.chain(vm.measurements)
      .groupBy('dataCaptureDate')
      .map((measurements) => {

        return {
          category: 'Datacapture: ' + measurements[0].dataCaptureDate,
          list : measurements
        };
      })
      .value().slice();

      vm.measurementSelected = _.indexBy(current, 'id');

      // clearing the filter to force update the list
      vm.filteredList = vm.groupedList.slice();
      vm.searchTerm = '';
    }
    else {
      vm.measurement = {};
      vm.measurementSelected = {};
    }
  };

  MeasurementStore.on(MeasurementStore.Events.ActiveSaved, () => {

    const active = MeasurementStore.get('active');
    if (active && MeasurementStore.isNewRecord(active)) {
      SaturnGrowl.newGrowl('Processing your new measurement.', {
        id: 'measurement-notif',
        time: -1
      });
    }
  });

  MeasurementStore.on(MeasurementStore.Events.MeasurementUpdated, (newMeasurement) => {

    if (newMeasurement.status === 'completed') {
      SaturnGrowl.newGrowl('Your measurement ' + newMeasurement.name + ' for the site ' + newMeasurement.site.name + ' is ready!', {
        id: 'measurement-notif',
        time: -1
      });
    }
    else if (newMeasurement.status === 'processing') {
      SaturnGrowl.newGrowl('Your measurement ' + newMeasurement.name + ' for the site ' + newMeasurement.site.name + ' is being processed!', {
        id: 'measurement-notif',
        time: -1
      });
    }
    else if (newMeasurement.status === 'error') {
      const errorMessage = `An error occurred while processing ${newMeasurement.name} ` +
        ` for ${newMeasurement.site.name}. Please verify the polygon does not ` +
        ' extend into the satellite map before trying again.';
      SaturnGrowl.newGrowl(errorMessage, {
        id: 'measurement-notif',
        type: 'warning',
        time: -1
      });
    }
  });

  // TODO: This is repeated in several navLeft children directives.
  // Refactor to a central place
  vm.closeDrawer = (options) => {

    options = options || {};
    if (options.prompt) {
      $rootScope.$broadcast(options.prompt);
    }
    else {
      NavActions.CloseDrawer.dispatch();
    }
  };

  vm.hasEditPermissions = (measurement) => {

    const permissions = MeasurementStore.getPermissions(measurement.id);
    return permissions.edit;
  };

  vm.hasDeletePermissions = (measurement) => {

    const permissions = MeasurementStore.getPermissions(measurement.id);
    return permissions.delete;
  };

  vm.deleteMeasurement = (measurement, $event) => {

    $event.stopPropagation();
    $rootScope.$broadcast('dialog:measurement:promptDelete', {
      id: measurement.id
    });
  };

  $scope.$on('dialog:measurement:confirmDelete', (ev, data) => {

    MapActions.DestroyMeasurement.dispatch(data.id);
    MeasurementStore.once(MeasurementStore.Events.MeasurementDestroyed, () => {

      MapActions.MeasurementEditEnd.dispatch(true);
    });
  });

  vm.editMeasurement = (measurement, $event) => {

    $event.stopPropagation();
    MapActions.EditMeasurementStart.dispatch(measurement.id);
  };

  //////////////////////////////////////////////////////////////////
  // Event Handlers
  //////////////////////////////////////////////////////////////////

  const onSelectedItem = (ev, data) => {

    const measurementId = data.item.id;
    MeasurementStore.activate(measurementId);
    ev.stopPropagation();
  };

  const onDeselectedItem = (ev, data) => {

    const measurementId = data.item.id;
    MeasurementStore.deactivate(measurementId);
    ev.stopPropagation();
  };

  $scope.$on('list:deselectedItem', onDeselectedItem);
  $scope.$on('list:selectedItem', onSelectedItem);
  MeasurementStore.on(MeasurementStore.Events.Changed, _loadMeasurements);
  TopControlsStore.on(TopControlsStore.Events.ChangedMap, _loadMeasurements);
  // Initialization section

  _loadMeasurements();
};

ListController.$inject = ['$scope', '$rootScope', 'sbFlux', 'NavActions', 'SaturnGrowl'];

module.exports = ListController;



// WEBPACK FOOTER //
// ./src/app/dash/nav/navLeft/measurements/list/MeasurementListController.js